import { useEffect, useState } from "react";
import { getJsonFromString, ReadObjectProp } from "../../../common/commonHelper";
import { ChildFieldForm } from "./ChildFieldForm";

const _props2 = {
    inputForm: {},
    currentFormField: {},
    controlConfig: {},
    childFormConfig: [],
    backgroundColor: '',
    childFormRef: {}
}
export  function ChildFormController(props = _props2) {
    const { formState: { errors }, getValues: inputForm_getValues, setValue: setInputFormValue } = props.inputForm;
    const parent_field = props.controlConfig?.mappedParentField;
    const error = ReadObjectProp(props.currentFormField.name, errors)
  

    const parent_field_value = (inputForm_getValues() || {})[parent_field];

    const fields = props?.childFormConfig?.map(x => x.field) || [];

    let json_val = getJsonFromString(props?.currentFormField?.value);
    json_val = fields.every(f => json_val[f]) ? json_val : {}
    const [value, setValue] = useState(json_val)

    useEffect(() => {
        const isValidFormData = isValidFieldData(json_val)
        setInputFormValue(props.currentFormField.name, !isValidFormData ? undefined : getFieldData(json_val))
    }, [])


    useEffect(() => {
        const isValidFormData = isValidFieldData(json_val)
        props?.currentFormField?.onChange(!isValidFormData ? undefined : getFieldData(json_val))
    }, [parent_field_value])

    function setIncomingFieldValue(json, errors) {
        if (json && Object.keys(json).length > 0 && fields.every(f => json[f])) {
            props?.currentFormField?.onChange(getFieldData(json))
        }
        else {
            props?.currentFormField?.onChange(undefined)
            setInputFormValue(props.currentFormField.name, undefined)
        }
    }
    function isValidFieldData(formValues) {
        return formValues && Object.keys(formValues).length > 0 && fields.every(f => formValues[f])
    }

    function getFieldData(json) {
        return JSON.stringify(json)
    }

    function setData(vo, formErrors) {
        setValue(vo);
        setIncomingFieldValue(vo, formErrors);
    }
    const defaultValue = json_val || {}

    return <ChildFieldForm
        defaultValue={defaultValue}
        error={error}
        fields={fields}
        setData={setData}
        key={parent_field_value}
        formFields={props.childFormConfig}
        backgroundColor={props.backgroundColor}
        childFormRef = {props.childFormRef}
        inputForm = {props.inputForm}
    />
}